(() => {
  setTimeout(async () => {
    const cartItems = await (await fetch(`${window.FoxTheme.routes.root_url}cart?view=markets-check`)).json();
    const updates = {};
    const excludedIds = [51142450872663]; // variant ids to exclude from auto-removal
    cartItems.forEach(item => { // remove items that are not available in the current market
      if (excludedIds.includes(item.id)) return;
      if (item.available_in_market === false) {
        updates[item.key.toString()] = 0;
      }
    });
    cartItems.forEach(item => { // remove items that have been set as out-of-stock
      if (excludedIds.includes(item.id)) return;
      if (item.is_out_of_stock === true) {
        updates[item.key.toString()] = 0;
      }
    });
    cartItems.forEach(item => { // check and autocorrect wrong subscription qtys
      const key = item.key.toString();
      if (key in updates) return;
      const step = parseInt(item.step, 10);
      if (item.is_subscription === true && step > 1 && item.quantity % step !== 0) {
        updates[key] = Math.ceil(item.quantity / step) * step;
      }
    });
    if (Object.keys(updates).length > 0) {
      let sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: {sections}
      }));
      const cartJson = await (await fetch(`${window.FoxTheme.routes.cart_update_url}.js`, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({
          updates: updates,
          sections: sections
        })
      })).json();
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart: cartJson});
    }
  }, 300);
})();
